import Backbone from 'backbone';
import _ from 'underscore';

import { ProviderTransitionModel } from './ProviderTransitionModel';

export const ProviderTransitionCollection = Backbone.Collection.extend({

	model: ProviderTransitionModel,
	
	initialize: function() {
		this.channel = Backbone.Radio.channel( 'AppChannel' );
		this.app = this.channel.request( 'app' );
	},

	downloadCSV: function() {
		alert('download CSV');
	}

});